<template>
  <div class="subject-select">
    <ul>
      <li v-for="item in list" :key="item.id" :class="{active: item.id === active}">
        <span>{{ item.value ? item.value : item.label }}</span>
      </li>
    </ul>
    <div class="container" v-if="active === 0">
      <div @click="selecteStage(item)" class="stage-item" v-for="item in stageList" :key="item.id">{{ item.text }}</div>
    </div>
    <div class="container" v-if="active === 1">
      <div @click="selecteGrade(item)" class="stage-item" v-for="item in gradeRealList" :key="item.id">
        {{ item.text }}
      </div>
    </div>
    <div class="container" v-if="active === 2">
      <div @click="selecteSuject(item)" class="stage-item" v-for="item in subjectsList" :key="item.id">
        {{ item.name }}
      </div>
    </div>
    <div class="container" v-if="active === 3">
      <div @click="hasSelecteVersion(item)" class="stage-item" v-for="item in versionList" :key="item.id">
        {{ item.name }}
      </div>
    </div>
    <div class="container" v-if="active === 4">
      <template v-if="categoryList.length">
        <div class="category-container">
          <div
            @click="categoryActive = index"
            :class="{categoryActive: categoryActive === index}"
            v-for="(item, index) in categoryList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
        <div style="padding-right:16px">
          <tree @choose="chooseItem" @open="openItem" :data="[categoryList[categoryActive]]"></tree>
        </div>
      </template>
      <template v-else>
        <van-empty description="暂无"></van-empty>
      </template>
    </div>
    <div class="btn-container">
      <van-button @click="save" block round type="info">确定</van-button>
    </div>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getStage, getGrade, getSubject, getVersion, getTree} from '@/api'
export default {
  components: {
    tree: () => import('@/components/tree.vue')
  },
  data() {
    return {
      list: [
        {
          id: 0,
          label: '学段',
          value: ''
        },
        {
          id: 1,
          label: '年级',
          value: ''
        },
        {
          id: 2,
          label: '学科',
          value: ''
        },
        {
          id: 3,
          label: '版本',
          value: ''
        }
      ],
      active: 0,
      categoryActive: 0,
      stageList: [],
      gradeList: [],
      gradeRealList: [],
      subjectsList: [],
      versionList: [],
      categoryList: [],
      stageId: -1,
      gradeId: -1,
      subjectId: -1,
      versionId: -1,
      categoryId: -1
    }
  },
  created() {
    this.init()
    this.selecteVersion()
  },
  methods: {
    formatData(data) {
      for (const obj of data) {
        obj.checked = false
        obj.defaultOpen = false
        if (obj.children && obj.children.length) {
          this.formatData(obj.children)
        }
      }
    },
    openItem(item) {
      item.defaultOpen = !item.defaultOpen
      this.categoryList = JSON.parse(JSON.stringify(this.categoryList))
    },
    chooseItem(item) {
      this.restOpenData(this.categoryList)
      item.checked = true
      this.categoryId = item.id
      this.categoryList = JSON.parse(JSON.stringify(this.categoryList))
    },
    restOpenData(arr) {
      for (const item of arr) {
        item.checked = false
        if (item.children && item.children.length) {
          this.restOpenData(item.children)
        }
      }
    },
    // =====================================
    save() {
      if (
        this.stageId === -1 &&
        this.gradeId === -1 &&
        this.subjectId === -1 &&
        this.versionId === -1 &&
        this.categoryId === -1
      ) {
        this.$Toast.fail('请选择')
      } else {
        this.$router.push({
          path: '/discover',
          query: {
            stageId: this.stageId,
            gradeId: this.gradeId,
            subjectId: this.subjectId,
            versionId: this.versionId,
            categoryId: this.categoryId,
            index: 1
          }
        })
      }
    },
    init() {
      // 学段
      getStage().then(res => {
        this.stageList = res.data
      })
      // 年级
      getGrade().then(res => {
        this.gradeList = res.data
      })
    },
    selecteStage(item) {
      this.stageId = item.code
      this.getSubjectByCode(item.code)
      // next
      if (item.code === '0') {
        this.gradeRealList = this.gradeList.slice(6, 9)
      } else if (item.code === '1') {
        this.gradeRealList = this.gradeList.slice(0, 6)
      } else {
        this.gradeRealList = this.gradeList.slice(0, 3)
      }

      this.active = 1
    },
    getSubjectByCode(periodld) {
      const params = {
        subjectType: '378953758199259136',
        periodld
      }
      getSubject(params).then(res => {
        this.subjectsList = res.data
      })
    },
    selecteSuject(item) {
      this.subjectId = item.id
      this.active = 3
    },
    selecteGrade(item) {
      this.gradeId = item.code
      this.active = 2
    },
    selecteVersion() {
      const params = {
        orgId: localStorage.getItem('orgId')
      }
      getVersion(params).then(res => {
        this.versionList = res.data
      })
    },
    hasSelecteVersion(item) {
      this.versionId = item.id
      this.getCategoryTree()
    },
    getCategoryTree() {
      const params = {
        textbookVersionId: this.versionId,
        subjectId: this.subjectId,
        gradeId: this.gradeId,
        periodId: this.stageId
      }
      getTree(params).then(res => {
        this.categoryList = res.data
        this.formatData(this.categoryList)
        this.active = 4
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subject-select {
  height: 100vh;
  > ul {
    display: flex;
    align-items: center;
    background: #fff;
    height: 40px;
    li {
      text-align: center;
      flex: 1;
      padding: 10px 0;
      span {
        padding: 7px 0;
        font-size: 14px;
      }
    }
    li.active span {
      border-bottom: 3px solid #4465f3;
    }
  }
}
div.container {
  height: calc(100vh - 120px);
  overflow-y: scroll;
  div.stage-item {
    padding: 20px 33px;
    font-size: 14px;
  }
}

.btn-container {
  height: 80px;
  padding: 0 16px;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.category-container {
  height: 72px;
  background: #f4f6f9;
  display: flex;
  align-items: center;
  justify-content: space-around;
  div {
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    padding: 0 20px;
    line-height: 32px;
    max-width: 50%;
    font-size: 12px;
    color: #606266;
  }
  div.categoryActive {
    color: #4465f3;
    background: rgba(68, 101, 243, 0.16);
  }
  div.active {
    color: #4465f3;
    background: rgba(68, 101, 243, 0.16);
  }
}
</style>
